import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'includes'
})
export class IncludesPipe implements PipeTransform {
    transform(values: Array<any>, query: any): boolean {
        return values.includes(query);
    }
}
